import { render, staticRenderFns } from "./OnlyContent.vue?vue&type=template&id=7de5c692"
import script from "./OnlyContent.vue?vue&type=script&lang=js"
export * from "./OnlyContent.vue?vue&type=script&lang=js"
import style0 from "./OnlyContent.vue?vue&type=style&index=0&id=7de5c692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports